<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <form name="contactForm" [formGroup]="shortCodeForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <mat-label>{{ "Operadores" | translate }}*</mat-label>
        <mat-form-field appearance="outline">
            <mat-select [disabled]="action == recordAction.Update" placeholder=""
                (selectionChange)="changeOperator($event)" formControlName="operator_id">
                <mat-option>-- {{ "Seleccionar" | translate }} --</mat-option>
                <mat-option *ngFor="let operator of operators" [value]="operator.id">
                    {{ operator.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-label>{{ "Short Codes" | translate }}*</mat-label>
        <mat-form-field appearance="outline">
            <mat-select formControlName="shortCodesControl" [(ngModel)]="this.operator.ShortCodes"
                [compareWith]="compareFn" placeholder="" multiple required
                (selectionChange)="onChangeShortCode($event)">
                <mat-option *ngFor="let s of shortCodes" [value]="s">
                    {{ s.value }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="end end">
            <button mat-raised-button (click)="save()" class="submit-button" [disabled]="shortCodeForm.invalid"
                aria-label="Guardar">
                <span class="material-icons-outlined"> save </span>
                <span> {{ "Guardar" | translate }}</span>
            </button>
        </div>
    </form>
</wtf-dialogcontent>